import React from 'react';
import { ProductDetailForm } from '../ProductDetailForm/ProductDetailForm';
import { Quantity } from '../ProductQuantity/ProductQuantity';
import { Price } from '../../../../../UI/Price/Price';
import { WishListMessage } from '../../../../Shared/Content/ProductDetail/WishListMessage/WishListMessage';
import { AddToBrandFavorites } from '../AddToBrandFavorites/AddToBrandFavorites';
import ProductDetailSwatches from '../../../../Shared/Content/ProductDetail/ProductDetailSwatches/ProductDetailSwatches';
import InvalidCombo from '../InvalidCombo/InvalidCombo';
// import Title from '../../ProductDetail/ProductTitle/ProductTitle';

export class ProductItemAttrComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.thisAttributeError = {};
    this.state.thisAttributeError.hasError = false;
    this.state.cacheAttrMap = this.generateCacheAttrMap();
    this.state.quantities = [];
    this.state.quantityEvents = [];
    this.state.colors = [];
    this.state.colorEvents = [];
    this.state.swatchGroups = [];
    for (var i = 0; i < this.props.contentData.itemAttrDisplayInfo.attrGroups.length; i++) {
      var thisAttrGroup = this.props.contentData.itemAttrDisplayInfo.attrGroups[i];
      this.state.quantities.push({ value: 1, errored: false });
      this.state.quantityEvents.push(undefined);
      this.state.colors.push({ value: '', errored: false });
      this.state.colorEvents.push(undefined);
      this.state.swatchGroups.push(this.initSwatchGroups(thisAttrGroup.swatchGroups));
    }

    this.updateAttributeAndAddToBag = this.updateAttributeAndAddToBag.bind(this);
    this.updateAttributeAndAddToWishlist = this.updateAttributeAndAddToWishlist.bind(this);
    this.updateAttributeAndAddToRegistry = this.updateAttributeAndAddToRegistry.bind(this);
    this.updateAttributeAndAddToFavorites = this.updateAttributeAndAddToFavorites.bind(this);
    this.updateQuantities = this.updateQuantities.bind(this);
    this.updateColors = this.updateColors.bind(this);
    this.forceItemQuantity = this.forceItemQuantity.bind(this);
  }

  initSwatchGroups(swatchGroups) {
    var returnSwatchGroups = JSON.parse(JSON.stringify(swatchGroups));
    for (var i = 0; i < returnSwatchGroups.length; i++) {
      var thisSwatchGroup = returnSwatchGroups[i];
      for (var j = 0; j < thisSwatchGroup.swatches.length; j++) {
        var thisSwatch = thisSwatchGroup.swatches[j];
        var thisSwatchAttrInfo = this.state.cacheAttrMap[thisSwatch.colorForSwatch] || {};
        thisSwatch.selectedValue = thisSwatchAttrInfo.selectedValue;
        thisSwatch.attrId = thisSwatchAttrInfo.attrId;
      }
    }
    return returnSwatchGroups;
  }

  fakeQuantityObject() {
    return {
      target: {
        value: '1',
        getAttribute: function (attribute) {
          if (attribute == 'data-minimum') {
            return 1;
          }
          if (attribute == 'data-maximum') {
            return 99;
          }
        },
      },
    };
  }

  generateCacheAttrMap() {
    var returnObject = {};
    for (var i = 0; i < this.props.contentData.attributes.length; i++) {
      var thisAttr = this.props.contentData.attributes[i];
      var thisAttrId = thisAttr.attrId;
      for (var j = 0; j < thisAttr.values.length; j++) {
        var thisAttrVal = thisAttr.values[j];
        var thisAttrValValue = thisAttrVal.value;
        var thisAttrValName = thisAttrVal.name;
        returnObject[thisAttrValName] = { attrId: thisAttrId, selectedValue: thisAttrValValue };
      }
    }
    return returnObject;
  }

  validateParameters(thisIndex, doNotRender) {
    var formValid = true;
    var thisColorEvent = this.state.colorEvents[thisIndex];
    var thisQuantityEvent = this.state.quantityEvents[thisIndex];
    if (!thisColorEvent || thisColorEvent.target.value == '') {
      if (!doNotRender) this.state.colors[thisIndex].errored = true;
      formValid = false;
    }
    if (thisQuantityEvent && thisQuantityEvent.target.value == '') {
      if (!doNotRender) this.state.quantities[thisIndex].errored = true;
      formValid = false;
    }
    if (!formValid && !doNotRender) {
      this.setState({}); //to update visuals since we won't be doing any more work this click
      this.props.passedFunctions.formNotValid();
    }
    return formValid;
  }

  updateAttributeAndAddToBag(event) {
    const thisIndex = event.target.getAttribute('data-index');
    const thisSelectValue = event.target.form.querySelector('select').value;
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.updateAttributeState(
      thisAttrName,
      this.props.currentAttributeState[thisAttrName].selectedValue,
      'Item',
      event.target.getAttribute('data-attritem'),
      thisSelectValue
    );
    this.props.passedFunctions.addToBagClicked();
    this.props.passedFunctions.checkForErrorsItemAttr();
    this.setState({ indexClicked: thisIndex });
    if (this.validateParameters(thisIndex)) {
      if (this.state.quantityEvents[thisIndex]) {
        this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
      } else {
        this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
      }
      this.props.passedFunctions.ajaxAddToBag(event);
    } else {
      this.state.thisAttributeError.hasError = true;
    }
  }

  updateAttributeAndAddToWishlist(event) {
    const thisIndex = event.target.getAttribute('data-index');
    const thisSelectValue = event.target.form.querySelector('select').value;
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.updateAttributeState(
      thisAttrName,
      this.props.passedFunctions.parentState.currentAttributeState[thisAttrName].selectedValue,
      'Item',
      event.target.getAttribute('data-attritem'),
      thisSelectValue
    );
    this.props.passedFunctions.addToBagClicked();
    this.props.passedFunctions.checkForErrorsItemAttr();
    this.setState({ indexClicked: thisIndex });
    if (this.validateParameters(thisIndex)) {
      if (this.state.quantityEvents[thisIndex]) {
        this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
      } else {
        this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
      }
      // this.props.passedFunctions.updateAttribute(this.state.colorEvents[thisIndex]);
      this.props.passedFunctions.ajaxAddToWishlist(event);
    }
  }

  updateAttributeAndAddToRegistry(event) {
    const thisIndex = event.target.getAttribute('data-index');
    const thisSelectValue = event.target.form.querySelector('select').value;
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.updateAttributeState(
      thisAttrName,
      this.props.passedFunctions.parentState.currentAttributeState[thisAttrName].selectedValue,
      'Item',
      event.target.getAttribute('data-attritem'),
      thisSelectValue
    );
    this.props.passedFunctions.addToBagClicked();
    this.props.passedFunctions.checkForErrorsItemAttr();
    this.setState({ indexClicked: thisIndex });
    if (this.validateParameters(thisIndex)) {
      if (this.state.quantityEvents[thisIndex])
        this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
      if (this.state.quantityEvents[thisIndex]) {
        this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
      } else {
        this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
      }
      // this.props.passedFunctions.updateAttribute(this.state.colorEvents[thisIndex]);
      this.props.passedFunctions.ajaxAddToRegistry(event);
    }
  }

  async updateAttributeAndAddToFavorites(event) {
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.updateAttributeState(
      thisAttrName,
      this.props.passedFunctions.parentState.currentAttributeState[thisAttrName].selectedValue,
      'Item',
      event.target.getAttribute('data-attritem')
    );
    this.props.passedFunctions.updateAttribute(event);
    await this.props.passedFunctions.ajaxAddToBrandFavorites(event);
  }

  updateQuantities(event, index) {
    var maximumQuantity = event.target.getAttribute('data-maximum') * 1,
      minimumQuantity = event.target.getAttribute('data-minimum') * 1,
      targetValue = event.target.value || event.target.getAttribute('data-value');
    if (targetValue == null || targetValue == undefined) targetValue = '';
    let isANum = !isNaN(targetValue),
      isANum_space = isANum && targetValue.toString().indexOf(' ') > -1,
      decimalNum = targetValue.toString().indexOf('.') > -1,
      noPeriodsOrSpaces = !(isANum_space || decimalNum);
    if (
      targetValue == '' ||
      (isANum && noPeriodsOrSpaces && targetValue <= maximumQuantity && targetValue >= minimumQuantity)
    ) {
      var newQuantitiesObject = JSON.parse(JSON.stringify(this.state.quantities));
      newQuantitiesObject[index].value = targetValue;
      newQuantitiesObject[index].errored = false;
      if (event.target.getAttribute('data-value')) {
        var fakeModifiedQuantityObject = this.fakeQuantityObject();
        fakeModifiedQuantityObject.target.value = targetValue;
        this.state.quantityEvents[index] = fakeModifiedQuantityObject;
      } else {
        this.state.quantityEvents[index] = {
          target: event.target,
        };
      }
      this.setState({
        quantities: newQuantitiesObject,
      });
    }
  }

  forceItemQuantity(event, index) {
    var newQuantitiesObject = JSON.parse(JSON.stringify(this.state.quantities));
    newQuantitiesObject[index].value = 1;
    newQuantitiesObject[index].errored = false;
    if (event.target.getAttribute('data-value')) {
      var fakeModifiedQuantityObject = this.fakeQuantityObject();
      fakeModifiedQuantityObject.target.value = 1;
      this.state.quantityEvents[index] = fakeModifiedQuantityObject;
    } else {
      this.state.quantityEvents[index] = {
        target: event.target,
      };
    }
    this.setState({
      quantities: newQuantitiesObject,
    });
  }

  updateColors(event, index) {
    this.props.passedFunctions.updateAttributeState(
      'Color',
      event.target.getAttribute('data-swatchcolor') || event.target.value
    );
    var newColorsObjects = JSON.parse(JSON.stringify(this.state.colors));
    newColorsObjects[index].value =
      event.target.value ||
      event.target.getAttribute('data-attrval') ||
      event.target.getAttribute('data-swatchcolor') ||
      '';
    newColorsObjects[index].errored = false;
    this.state.colorEvents[index] = { target: event.target };
    for (var i = 0; i < this.state.swatchGroups[index].length; i++) {
      var thisSwatchGroup = this.state.swatchGroups[index][i];
      for (var j = 0; j < thisSwatchGroup.swatches.length; j++) {
        var thisSwatch = thisSwatchGroup.swatches[j];
        thisSwatch.selected = event.target.getAttribute('data-swatchcolor') || event.target.value;
      }
    }
    this.setState({ colors: newColorsObjects });
  }

  pickSelectedImage(thisItemAttrGroup, index) {
    var foundImage = false;
    var foundSwatch;
    if (this.state.swatchGroups[index]) {
      for (var iSwatchGroup = 0; iSwatchGroup < this.state.swatchGroups[index].length; iSwatchGroup++) {
        var thisSwatchGroup = this.state.swatchGroups[index][iSwatchGroup];
        for (var iSwatch = 0; iSwatch < thisSwatchGroup.swatches.length; iSwatch++) {
          var thisSwatch = thisSwatchGroup.swatches[iSwatch];
          if (thisSwatch.selected) {
            foundImage = true;
            foundSwatch = thisSwatch;
          }
        }
      }
    }
    if (foundImage) {
      return foundSwatch.fullImage;
    } else {
      return false;
    }
  }

  thisAttributeSelected(thisAttributeValue, index) {
    let returnBool = false;
    let attrIndex = index;
    if (this.props.currentAttributeState) {
      if (thisAttributeValue === this.props.currentAttributeState.Item.selectedValue) {
        returnBool = true;
      } else {
        if (
          attrIndex === 0 &&
          this.props.passedFunctions.parentState.isAddToBrandFavs === true &&
          this.props.currentAttributeState.Item.selectedValue === undefined
        ) {
          returnBool = true;
        }
      }
    }
    return returnBool;
  }

  render() {
    var itemAttrDisplayInfo = this.props.contentData.itemAttrDisplayInfo,
      productItem__image,
      productItem__description,
      productItem__shopperActions1,
      productItem__shopperActions2;
    if (this.props.siteFormat != 'mobile') {
      productItem__image = `col-sm-2`;
      productItem__description = `col-sm-3`;
      productItem__shopperActions1 = `col-sm-4`;
      productItem__shopperActions2 = `col-sm-3`;
    } else {
      productItem__image = `col-6`;
      productItem__description = `col-6`;
      productItem__shopperActions1 = `col-12`;
      productItem__shopperActions2 = `col-12`;
    }
    return (
      <div className='row'>
        {itemAttrDisplayInfo.attrGroups.map((thisItemAttrGroup, index) => (
          <div className='col-12 productItem__wrapper' key={index}>
            <ProductDetailForm contentData={this.props.contentData} passedFunctions={this.props.passedFunctions}>
              <div className={`${productItem__image} productItem__img`}>
                <img
                  src={`//dimg.dillards.com/is/image/DillardsZoom/productItem/${this.props.contentData.productNameForURL}/${this.pickSelectedImage(thisItemAttrGroup, index) || thisItemAttrGroup.itemImage}.jpg`}
                  alt={
                    this.props.contentData.brandNameForTitle +
                    ' ' +
                    this.props.contentData.productName +
                    '-' +
                    thisItemAttrGroup.itemName.split('#double;').join('"')
                  }
                />
              </div>

              <div className={`${productItem__description} productItem__description`}>
                <div className='productItem__title'>
                  <span>{thisItemAttrGroup.itemName.split('#double;').join('"')}</span>
                </div>
              </div>
              <div className={`${productItem__shopperActions1}`}>
                <div className='p-b-10'>
                  <select
                    value={this.state.colors[index].value}
                    className='attrSelect form-control'
                    onChange={(event) => {
                      this.updateColors(event, index);
                    }}
                    data-index={index}
                    data-attrid={this.props.contentData.attributes[1].attrId}
                    data-attrtype={this.props.contentData.attributes[1].attrName + 'ID'}
                    data-attritem={thisItemAttrGroup.itemName.split('#double;').join('"')}
                    aria-describedby={
                      this.props.passedFunctions.parentState.checkForErrors == true ? 'invalidComboContainer' : ''
                    }
                  >
                    {!this.state.colors[index].value && (
                      <option value='' key='default'>
                        Color
                      </option>
                    )}
                    {thisItemAttrGroup.colors.map((thisColor, indexColor) => (
                      <option
                        key={indexColor}
                        data-attritem={thisItemAttrGroup.itemName.split('#double;').join('"')}
                        value={thisColor.display.split('#double;').join('"')}
                      >
                        {thisColor.display.split('#double;').join('"')}
                        <span className='price'>{thisColor.displayPrice ? ` - ${thisColor.displayPrice}` : ''}</span>
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  {this.state.swatchGroups[index].map((swatchGroup, indexSwatchGroup) => (
                    <div key={indexSwatchGroup}>
                      <Price pricing={swatchGroup.pricing} />
                      <ul className='swatches'>
                        {swatchGroup.swatches.map((swatch, indexSwatch) => (
                          <li
                            key={swatch.colorForSwatch}
                            className='swatches__item'
                            aria-selected={`${swatch.selected ? 'true' : 'false'}`}
                            role='button'
                          >
                            <img
                              className={`swatches__img available ${swatch.selected ? ' selected' : ''}`}
                              src={`//dimg.dillards.com/is/image/DillardsZoom/${swatch.swatchImg}`}
                              alt={`Color Swatch - ${swatch.colorForSwatch}`}
                              onClick={(event) => {
                                this.updateColors(event, index);
                              }}
                              data-swatchcolor={swatch.colorForSwatch}
                              data-attrval={swatch.selectedValue}
                              data-attrid={swatch.attrId}
                              data-attrvalname={swatch.colorForSwatch}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
              <div className={`${productItem__shopperActions2}`}>
                <Quantity
                  className={this.state.quantities[index].errored ? 'errored' : ''}
                  updateQuantity={(event) => {
                    this.updateQuantities(event, index);
                  }}
                  quantity={this.state.quantities[index].value}
                  quantityErrored={this.state.quantities[index].errored}
                  contentData={this.props.contentData}
                  passedAppFunctions={this.props.passedAppFunctions}
                  isProductItem='true'
                  forceItemQuantity={(event) => {
                    this.forceItemQuantity(event, index);
                  }}
                  prodIndex={index}
                  multipleProds='yes'
                />
                <div className='addToBagContainer'>
                  <InvalidCombo
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                    itemKey={index}
                    indexClicked={this.state.indexClicked}
                    currentAttributeState={this.props.passedFunctions.parentState.currentAttributeState}
                  />
                  <button
                    role='button'
                    type='button'
                    id='add-to-bag'
                    className='btn btn-primary btn-block'
                    data-attritem={thisItemAttrGroup.itemName.split('#double;').join('"')}
                    data-attrval={thisItemAttrGroup.attrValue}
                    data-attrid={itemAttrDisplayInfo.itemAttrName}
                    data-index={index}
                    onClick={this.updateAttributeAndAddToBag}
                  >
                    Add To Bag
                  </button>
                </div>
                {this.thisAttributeSelected(thisItemAttrGroup.itemName.split('#double;').join('"'), index) ? (
                  <WishListMessage
                    passedFunctions={this.props.passedFunctions}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                ) : (
                  ''
                )}
                {!this.props.passedAppFunctions.isInternational() ? (
                  <button
                    className='btn btn-tertiary btn-block'
                    type='button'
                    role='button'
                    id='add-to-wishlist'
                    data-attrval={thisItemAttrGroup.attrValue}
                    data-attrid={itemAttrDisplayInfo.itemAttrName}
                    data-attritem={thisItemAttrGroup.itemName.split('#double;').join('"')}
                    data-index={index}
                    onClick={this.updateAttributeAndAddToWishlist}
                  >
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44'>
                      <title>heart</title>
                      <g data-name='Layer 2'>
                        <g data-name='Layer 1'>
                          <path
                            className='cls-1'
                            d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                          />
                        </g>
                      </g>
                    </svg>
                    Add To Wish List
                  </button>
                ) : (
                  ''
                )}

                {!this.props.passedAppFunctions.isInternational() ? (
                  <button
                    className='btn btn-tertiary btn-block'
                    role='button'
                    type='button'
                    id='add-to-registry'
                    data-attrval={thisItemAttrGroup.attrValue}
                    data-attrid={itemAttrDisplayInfo.itemAttrName}
                    data-attritem={thisItemAttrGroup.itemName.split('#double;').join('"')}
                    data-index={index}
                    onClick={this.updateAttributeAndAddToRegistry}
                  >
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50.42 49.84'>
                      <title>gift</title>
                      <g data-name='Layer 2'>
                        <g data-name='Layer 1'>
                          <path d='M48,9.79H39.64a5.33,5.33,0,0,0-1-9.43,5.3,5.3,0,0,0-4.09.1c-2.16,1-8,7.3-9.37,8.82C23.8,7.76,18,1.42,15.81.46a5.33,5.33,0,0,0-5.1,9.33H2.45A2.45,2.45,0,0,0,0,12.24v4.39a2.45,2.45,0,0,0,2.45,2.45H3a3.46,3.46,0,0,0-.53,1.84V46.35a3.5,3.5,0,0,0,3.49,3.49H44.41a3.5,3.5,0,0,0,3.49-3.49V20.92a3.46,3.46,0,0,0-.53-1.84H48a2.45,2.45,0,0,0,2.45-2.45V12.24A2.45,2.45,0,0,0,48,9.79ZM35.36,2.3A3.32,3.32,0,0,1,38,8.39c-1.2.53-6.12.76-10.05.81C30.68,6.32,34.16,2.83,35.36,2.3ZM10.61,4A3.33,3.33,0,0,1,15,2.3c1.2.53,4.68,4,7.36,6.89-3.93,0-8.85-.28-10.05-.81h0A3.33,3.33,0,0,1,10.61,4ZM2,16.63V12.24a.43.43,0,0,1,.43-.43H24.2v5.26H2.45A.43.43,0,0,1,2,16.63ZM4.47,46.35V20.92a1.48,1.48,0,0,1,1.48-1.48H24.2V47.82H5.94A1.48,1.48,0,0,1,4.47,46.35Zm41.42,0a1.48,1.48,0,0,1-1.48,1.48H26.22V19.44H44.41a1.48,1.48,0,0,1,1.48,1.48Zm2.52-29.71a.43.43,0,0,1-.43.43H26.22V11.81H48a.43.43,0,0,1,.43.43Z' />
                        </g>
                      </g>
                    </svg>
                    Add To Registry
                  </button>
                ) : (
                  ''
                )}
                <AddToBrandFavorites
                  passedAppFunctions={this.props.passedAppFunctions}
                  contentData={this.props.contentData}
                  passedFunctions={this.props.passedFunctions}
                  passedOnClick={this.updateAttributeAndAddToFavorites}
                  passedDataIds={{
                    'data-attrval': thisItemAttrGroup.attrValue,
                    'data-attrid': itemAttrDisplayInfo.itemAttrName,
                    'data-index': index,
                  }}
                  dataAttrItem={thisItemAttrGroup.itemName.split('#double;').join('"')}
                />
              </div>
            </ProductDetailForm>
          </div>
        ))}
      </div>
    );
  }
}

export default ProductItemAttrComponent;
